import {
  Card,
  DateRow,
  IconRow,
  Left,
  ListWrap,
  Period,
  Periods,
  Right,
  TitleRow,
} from "./styles.ts";
import { CloudIcon } from "../../../../shared/ui/icons/cloudIcon.tsx";
import { COLORS } from "../../../../shared/consts";
import { useMemo } from "react";

type DayItem = {
  iso: string;
  dateText: string;
  title: string;
  periodsLabel?: string;
  dayTemp: string;
  nightTemp: string;
};

type Props = {
  days: DayItem[];
  isWidget?: boolean;
  handleToDays?: (dataIsp: string) => void;
  today?: Date;
  maxDate?: Date;
};

export const WeatherCalendarMobile = ({
  days,
  isWidget = false,
  handleToDays,
  today,
  maxDate,
}: Props) => {
  const tenDays = useMemo(() => {
    return days.slice(0, 10);
  }, [days]);

  return (
    <ListWrap $isWidget={isWidget}>
      {(isWidget ? tenDays : days).map((d) => (
        <Card
          key={d.iso}
          onClick={() => {
            if (
              today &&
              maxDate &&
              d.iso >= today.toISOString().split("T")[0] &&
              d.iso <= maxDate.toISOString()
            ) {
              handleToDays?.(d.iso);
            }
          }}
        >
          <Left>
            <DateRow>{d.dateText}</DateRow>
            <TitleRow>{d.title}</TitleRow>
          </Left>

          <Right>
            <IconRow>
              <CloudIcon />
              <span style={{ fontSize: 12, color: COLORS.FG.SOFT }}>
                {d.periodsLabel ?? "утро, день"}
              </span>
            </IconRow>

            <Periods>
              <Period>
                <span>День</span>
                <b>{d.dayTemp}</b>
              </Period>
              <Period>
                <span>Ночь</span>
                <b>{d.nightTemp}</b>
              </Period>
            </Periods>
          </Right>
        </Card>
      ))}
    </ListWrap>
  );
};
